import { render, staticRenderFns } from "./tag-group-add-modal.vue?vue&type=template&id=7cad91dd&scoped=true&"
import script from "./tag-group-add-modal.vue?vue&type=script&lang=js&"
export * from "./tag-group-add-modal.vue?vue&type=script&lang=js&"
import style0 from "./tag-group-add-modal.vue?vue&type=style&index=0&id=7cad91dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cad91dd",
  null
  
)

export default component.exports